import enTranslations from '@/locales/en.json';
import zhCNTranslations from '@/locales/zh-CN.json';

export type Locale = 'en' | 'zh-CN';

export const translations = {
  en: enTranslations,
  'zh-CN': zhCNTranslations,
};

export const defaultLocale: Locale = 'zh-CN';

export function getTranslation(locale: Locale = defaultLocale) {
  return translations[locale] || translations[defaultLocale];
}

// 简单的翻译函数，支持嵌套键
export function translate(
  locale: Locale,
  key: string,
  params?: Record<string, string | number>,
): string {
  const t = getTranslation(locale);
  const keys = key.split('.');
  let value: any = t;

  for (const k of keys) {
    if (value && typeof value === 'object' && k in value) {
      value = value[k];
    } else {
      return key; // 如果找不到翻译，返回键本身
    }
  }

  if (typeof value !== 'string') {
    return key;
  }

  // 替换参数
  if (params) {
    return value.replace(/\{\{(\w+)\}\}/g, (match, paramKey) => {
      return params[paramKey]?.toString() || match;
    });
  }

  return value;
}

